import { render, staticRenderFns } from "./SuperTouchMobile.vue?vue&type=template&id=1aed19ec&scoped=true&"
import script from "./SuperTouchMobile.vue?vue&type=script&lang=js&"
export * from "./SuperTouchMobile.vue?vue&type=script&lang=js&"
import style0 from "./SuperTouchMobile.vue?vue&type=style&index=0&id=1aed19ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed19ec",
  null
  
)

export default component.exports